<div class="noDeal" [ngClass]="{mobWidth:isMobileView}">
  <img src="assets/images/No_ Deals_Icon.svg" alt="no-deal-img"/>
  <div class="title" >Bummer! Currently, we do not have any deals.</div>
  <div class="sub-text" >Please check back later as we bring you some exciting offers.</div>
</div>
